import {
    WeChatChatroom,
    WeChatChatroomInfo, WeChatMsg, WeChatMsgGroup,
    WeChatPagination,
    WeChatSession,
    WeChatState,
    WeChatContact,
    WeChatRoomGroup,
} from "@/store/modules/weChat/types";
import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "@/store/types";
import { weChatAPI } from "@/api/weChat";
import { user } from '../user/index';


export const moduleName = "weChat";

export enum WeChatGetters {
    getWeChatSessionList = "GET_WECHAT_SESSION_LIST",
    getIsSessionLoading = "GET_SESSION_IS_LOADING",
    getIsSessionAllLoaded = "GET_IS_SESSION_ALL_LOADED",

    getWeChatContactList = "GET_WECHAT_CONTACT_LIST",
    getIsContactLoading = "GET_CONTACT_IS_LOADING",
    getIsContactAllLoaded = "GET_IS_CONTACT_ALL_LOADED",

    getIsMsgListLoading = "GET_MSG_LIST_IS_LOADING",
    getSelectedSession = "GET_SELECTED_SESSION",
    getSessionPagination = "GET_SESSION_PAGINATION",
    getContactPagination = "GET_CONTACT_PAGINATION",
    getChatRoomPagination = "GET_CHATROOM_PAGINATION",
    getMsgGroupByName = "GET_MSG_GROUP_BY_NAME",
    getIsMsgListAllLoadedByName = "GET_IS_MSG_LIST_ALL_LOADED_BY_NAME",
    getChatroom = "GET_CHATROOM",
    getChatroomInfo = "GET_CHATROOM_INFO",

    getWeChatChatroomList = "GET_WECHAT_CHATROOM_LIST",
    getIsChatroomLoading = "GET_CHATROOM_IS_LOADING",
    getIsChatroomAllLoaded = "GET_IS_CHATROOM_ALL_LOADED",
    getIsPaticipantsLoading = "GET_IS_PATICIPANS_LOADING",
    getIsPaticipantsAllLoadedByName = "GET_IS_PATICIPANS_ALL_LOADED_BY_NAME",

    getChatroomGroupByName = "GET_CHATROOM_GROUP_BY_NAME",
    getSelectMenu = "GET_SELECT_MENU",
    getMeId = "GET_ME_ID",
    getIdList = "GET_ID_LIST",
    getIsMeLoading = "GET_IS_ME_LOADING",

    getSearchTarget = "GET_SEARCH_TARGET",
    getSearchType = "GET_SEARCH_TYPE",
    getSearchContactList = "GET_SEARCH_CONTACT_LIST",
    getSearchConvList = "GET_SEARCH_CONV_LIST",
    getSearchChatList = "GET_SEARCH_CHAT_LIST",
    getIsSearchContactLoading = "GET_IS_SEARCH_CONTACT_LOADING",
    getIsSearchConvLoading = "GET_IS_SEARCH_CONV_LOADING",
    getIsSearchChatLoading = "GET_IS_SEARCH_CHAT_LOADING",
    getIsSearchContactAllLoaded = "GET_IS_SEARCH_CONTACT_ALL_LOADED",
    getIsSearchConvAllLoaded = "GET_IS_SEARCH_CONV_ALL_LOADED",
    getIsSearchChatAllLoaded = "GET_IS_SEARCH_CHAT_ALL_LOADED",
    getSearchContactPagination = "GET_SEARCH_CONTACT_PAGINATION",
    getSearchConvPagination = "GET_SEARCH_CONV_PAGINATION",
    getSearchChatPagination = "GET_SEARCH_CHAT_PAGINATION",
    getSearchMsgListMap = "GET_SEARCH_MSG_MAP",
    getIsSearchMsgLoading = "GET_IS_SEARCH_MSG_LOADING",
    getIsSearchMsgListAllLoadedByConvId = "GET_IS_SEARCH_MSG_ALL_LOADED_BY_CONV_ID",

}

export enum WeChatMutations {
    setWeChatSessionList = "SET_WECHAT_SESSION_LIST",
    setIsSessionLoading = "SET_SESSION_IS_LOADING",
    setIsSessionAllLoaded = "SET_IS_SESSION_ALL_LOADED",

    SetWeChatContactList = "SET_WECHAT_CONTACT_LIST",
    SetIsContactLoading = "SET_CONTACT_IS_LOADING",
    SetIsContactAllLoaded = "SET_IS_CONTACT_ALL_LOADED",

    setIsMsgListLoading = "SET_IS_MSG_LIST_LOADING",
    setSelectedSession = "SET_SELECTED_SESSION",
    setSessionPagination = "SET_SESSION_PAGINATION",
    setContactPagination = "SET_CONTACT_PAGINATION",
    setChatroomPagination = "SET_CHATROOM_PAGINATION",

    setMsgListByName = "SET_MSG_LIST_BY_NAME",
    setMsgPaginationByName = "SET_MSG_PAGINATION_BY_NAME",
    setMsgAllLoadedByName = "SET_MSG_ALL_LOADED_BY_NAME",
    setChatroom = "SET_CHATROOM",
    setChatroomInfo = "SET_CHATROOM_INFO",

    setWeChatChatroomList = "SET_WECHAT_CHATROOM_LIST",
    setIsChatroomLoading = "SET_IS_CHATROOM_LOADING",
    setIsChatroomAllLoaded = "SET_IS_CHATROOM_ALL_LOADED",

    setIsPaticipantsLoading = "SET_IS_PATICIPANtS_LOADING",
    setChatroomGroupByName = "SET_CHATROOM_GROUP_BY_NAME",
    setParticipantsAllLoadedByName = "SET_PATICIPANtS_ALL_LOADED_BY_NAME",
    setParticipantsPaginationByName = "SET_PATICIPANtS_PAGINATION_BY_NAME",

    setMeId = "SET_ME_ID",
    setIdList = "SET_ID_LIST",
    setIsMeLoading = "SET_IS_ME_LOADING",
    setSelectMenu = "SET_SELECT_MENU",
    resetAll = "RESET_ALL",

    setSearchType = "SET_SEARH_TYPE",
    setSearchTarget = "SET_SEARH_TARGET",
    setSearchContactList = "SET_SEARCH_CONTACT_LIST",
    setSearchConvList = "SET_SEARCH_CONV_LIST",
    setSearchChatList = "SET_SEARCH_CHAT_LIST",
    setIsSearchContactLoading = "SET_IS_SEARCH_CONTACT_LOADING",
    setIsSearchConvLoading = "SET_IS_SEARCH_CONV_LOADING",
    setIsSearchChatLoading = "SET_IS_SEARCH_CHAT_LOADING",
    setIsSearchContactAllLoaded = "SET_IS_SEARCH_CONTACT_ALL_LOADED",
    setIsSearchConvAllLoaded = "SET_IS_SEARCH_CONV_ALL_LOADED",
    setIsSearchChatAllLoaded = "SET_IS_SEARCH_CHAT_ALL_LOADED",
    setSearchContactPagination = "SGET_SEARCH_CONTACT_PAGINATION",
    setSearchConvPagination = "SET_SEARCH_CONV_PAGINATION",
    setSearchChatPagination = "SET_SEARCH_CHAT_PAGINATION",
    setSearchMsgListByName = "SET_SEARCH_MSG_LIST_BY_CONV_ID",
    setIsSearchMsgLoading = "SET_IS_SEARCH_MSG_LOADING",
    setSearchMsgPaginationByConvId = "SET_SEARCH_MSG_PAGINATION_BY_CONV_ID",
    setSearchMsgAllLoadedByConvId = "SET_SEARCH_MSG_ALL_LOADED_BY_CONV_ID",
    resetSearch = "RESET_SEARCH",

}

export enum WeChatActions {
    asyncGetSessionListByUid = "ASYNC_GET_SESSION_LIST_BY_UID",
    asyncGetContactListByUid = "ASYNC_GET_CONTACT_LIST_BY_UID",
    asyncGetChatroomListByUid = "ASYNC_GET_CHATROOM_LIST_BY_UID",
    asyncGetMsgListByUidAndName = "ASYNC_GET_MSG_LIST_BY_UID_AND_NAME",
    asyncGetChatroomInfoByUidAndName = "ASYNC_GET_CHATROOM_INFO_BY_UID_AND_NAME",
    asyncGetChatroomByUidAndName = "ASYNC_GET_CHATROOM_BY_UID_AND_NAME",
    asyncGetParticipantsByChatroomName = "ASYNC_GET_PARTICIPANTS_BY_CHATROOM_NAME",
    asyncGetMeId = "ASYNC_GET_ME_ID",

    asyncGetSearchingContactByUidAndTgId = "ASYNC_GET_SEARCHING_CONTACT_BY_Uid_AND_WECHAT_ID",
    asyncGetSearchingConvByUidAndTgId = "ASYNC_GET_SEARCHING_CONV_BY_Uid_AND_WECHAT_ID",
    asyncGetSearchingChatByUidAndTgId = "ASYNC_GET_SEARCHING_CHAT_BY_Uid_AND_WECHAT_ID",
    asyncGetSearchingMsgByNameAndTarget = "ASYNC_GET_SEARCHING_MSG_BY_NAME_AND_TARGET",
    asyncGetSearchingMsgByNameAndUserId = "ASYNC_GET_SEARCHING_MSG_BY_NAME_AND_USER_ID",
}

const defaultPagination: WeChatPagination = {
    page: 1,
    limit: 10,
};

const defaultChatroom: WeChatChatroom = {
    ChatRoomName: "",
    UserNameList: "",
    DisplayNameList: "",
    ChatRoomFlag: -1,
    Owner: { Valid: false },
    RoomData: "",
}

const defaultChatroomInfo: WeChatChatroomInfo = {
    ChatRoomName: "",
    Announcement: "",
    InfoVersion: "",
    AnnouncementEditor: "",
    AnnouncementPublishTime: -1,
    ChatRoomStatus: -1,
}

const defaultState: WeChatState = {
    me: "",
    idList: [],
    isMeLoading: false,
    selectedMenu: '1',
    sessionList: [],
    contactList: [],
    chatroomList: [],
    isSessionLoading: false,
    isSessionAllLoaded: false,
    isContactLoading: false,
    isContactAllLoaded: false,
    isMsgListLoading: false,
    selectedSession: null,
    sessionPagination: { ...defaultPagination },
    contactPagination: { ...defaultPagination },
    chatroomPagination: { ...defaultPagination },
    msgListMap: {},
    chatroom: { ...defaultChatroom },
    chatroomInfo: { ...defaultChatroomInfo },
    isChatroomLoading: false,
    isChatroomAllLoaded: false,
    isParticipantsLoading: false,
    chatroomParticipantsMap: {},

    searchType: "",
    searchTarget: "",
    searchingContact: [],
    searchingConversation: [],
    searchingChat: [],
    isSearchingContactLoading: false,
    isSearchingConvLoading: false,
    isSearchingChatLoading: false,
    isSearchingContactAllLoaded: false,
    isSearchingConvAllLoaded: false,
    isSearchingChatAllLoaded: false,
    searchingContactPagination: { ...defaultPagination },
    searchingConvPagination: { ...defaultPagination },
    searchingChatPagination: { ...defaultPagination },
    searchMsgListMap: {},
    isSearchingMsgLoading: false,

};
const state = { ...defaultState };

export const getters: GetterTree<WeChatState, RootState> = {
    [WeChatGetters.getWeChatSessionList](state): WeChatSession[] {
        return state.sessionList;
    },
    [WeChatGetters.getWeChatContactList](state): WeChatContact[] {
        return state.contactList;
    },
    [WeChatGetters.getWeChatChatroomList](state): WeChatContact[] {
        return state.chatroomList;
    },
    [WeChatGetters.getIsSessionLoading](state): boolean {
        return state.isSessionLoading;
    },
    [WeChatGetters.getIsContactLoading](state): boolean {
        return state.isContactLoading;
    },
    [WeChatGetters.getIsChatroomLoading](state): boolean {
        return state.isChatroomLoading;
    },
    [WeChatGetters.getIsSessionAllLoaded](state): boolean {
        return state.isSessionAllLoaded;
    },
    [WeChatGetters.getIsContactAllLoaded](state): boolean {
        return state.isContactAllLoaded;
    },
    [WeChatGetters.getIsChatroomAllLoaded](state): boolean {
        return state.isChatroomAllLoaded;
    },
    [WeChatGetters.getIsMsgListLoading](state): boolean {
        return state.isMsgListLoading;
    },
    [WeChatGetters.getIsPaticipantsLoading](state): boolean {
        return state.isParticipantsLoading;
    },
    [WeChatGetters.getSelectedSession](state): WeChatSession | null | WeChatContact {
        return state.selectedSession;
    },
    [WeChatGetters.getSessionPagination](state): WeChatPagination {
        return state.sessionPagination;
    },
    [WeChatGetters.getContactPagination](state): WeChatPagination {
        return state.contactPagination;
    },
    [WeChatGetters.getChatRoomPagination](state): WeChatPagination {
        return state.chatroomPagination;
    },
    [WeChatGetters.getMsgGroupByName]: (state) => (sessionName: string): WeChatMsgGroup => {
        if (state.msgListMap[sessionName]) {
            return state.msgListMap[sessionName];
        } else {
            return {
                pagination: { ...defaultPagination },
                isAllLoaded: false,
                msgList: []
            }
        }
    },
    [WeChatGetters.getChatroomGroupByName]: (state) => (chatroomName: string): WeChatRoomGroup => {
        if (state.chatroomParticipantsMap[chatroomName]) {
            return state.chatroomParticipantsMap[chatroomName];
        } else {
            return {
                pagination: { ...defaultPagination },
                isAllLoaded: false,
                userList: []
            }
        }
    },
    [WeChatGetters.getChatroom](state): WeChatChatroom {
        return state.chatroom;
    },
    [WeChatGetters.getChatroomInfo](state): WeChatChatroomInfo {
        return state.chatroomInfo;
    },

    [WeChatGetters.getIsMsgListAllLoadedByName]: (state) => (sessionName: string): boolean => {
        if (state.msgListMap[sessionName]) {
            return state.msgListMap[sessionName].isAllLoaded;
        }
        return false;
    },
    [WeChatGetters.getIsPaticipantsAllLoadedByName]: (state) => (chatroomName: string): boolean => {
        if (state.chatroomParticipantsMap[chatroomName]) {
            return state.chatroomParticipantsMap[chatroomName].isAllLoaded;
        }
        return false;
    },
    [WeChatGetters.getMeId](state): string {
        return state.me;
    },
    [WeChatGetters.getIdList](state): WeChatContact[] {
        return state.idList;
    },
    [WeChatGetters.getSelectMenu](state): string {
        return state.selectedMenu;
    },
    [WeChatGetters.getIsMeLoading](state): boolean {
        return state.isMeLoading;
    },
    [WeChatGetters.getSearchTarget](state): string {
        return state.searchTarget;
    },
    [WeChatGetters.getSearchType](state): string {
        return state.searchType;
    },
    [WeChatGetters.getSearchContactList](state): WeChatSession[] {
        return state.searchingContact;
    },
    [WeChatGetters.getSearchConvList](state): WeChatSession[] {
        return state.searchingConversation;
    },
    [WeChatGetters.getSearchChatList](state): WeChatSession[] {
        return state.searchingChat;
    },
    [WeChatGetters.getIsSearchContactLoading](state): boolean {
        return state.isSearchingContactLoading;
    },
    [WeChatGetters.getIsSearchConvLoading](state): boolean {
        return state.isSearchingConvLoading;
    },
    [WeChatGetters.getIsSearchChatLoading](state): boolean {
        return state.isSearchingChatLoading;
    },
    [WeChatGetters.getIsSearchContactAllLoaded](state): boolean {
        return state.isSearchingContactAllLoaded;
    },
    [WeChatGetters.getIsSearchConvAllLoaded](state): boolean {
        return state.isSearchingConvAllLoaded;
    },
    [WeChatGetters.getIsSearchChatAllLoaded](state): boolean {
        return state.isSearchingChatAllLoaded;
    },
    [WeChatGetters.getSearchContactPagination](state): WeChatPagination {
        return state.searchingContactPagination;
    },
    [WeChatGetters.getSearchConvPagination](state): WeChatPagination {
        return state.searchingConvPagination;
    },
    [WeChatGetters.getSearchChatPagination](state): WeChatPagination {
        return state.searchingChatPagination;
    },
    [WeChatGetters.getSearchMsgListMap]: (state) => (name: string): WeChatMsgGroup => {
        if (state.searchMsgListMap[name]) {
            return state.searchMsgListMap[name];
        } else {
            return {
                pagination: { ...defaultPagination },
                isAllLoaded: false,
                msgList: [],
            }
        }
    },
    [WeChatGetters.getIsSearchMsgLoading](state): boolean {
        return state.isSearchingMsgLoading;
    },
    [WeChatGetters.getIsSearchMsgListAllLoadedByConvId]: (state) => (name: string): boolean => {
        if (state.searchMsgListMap[name]) {
            return state.searchMsgListMap[name].isAllLoaded;
        } else {
            return false;
        }
    },

}

export const mutations: MutationTree<WeChatState> = {
    [WeChatMutations.setWeChatSessionList](state, payload: { sessionList: WeChatSession[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.sessionList = state.sessionList.concat(payload.sessionList);
        } else {
            state.sessionList = payload.sessionList;
        }
    },
    [WeChatMutations.SetWeChatContactList](state, payload: { contactList: WeChatContact[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.contactList = state.contactList.concat(payload.contactList);
        } else {
            state.contactList = payload.contactList;
        }
    },
    [WeChatMutations.setWeChatChatroomList](state, payload: { chatroomList: WeChatContact[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.chatroomList = state.chatroomList.concat(payload.chatroomList);
        } else {
            state.chatroomList = payload.chatroomList;
        }
    },
    [WeChatMutations.setIsSessionLoading](state, payload: boolean) {
        state.isSessionLoading = payload;
    },
    [WeChatMutations.SetIsContactLoading](state, payload: boolean) {
        state.isContactLoading = payload;
    },
    [WeChatMutations.setIsChatroomLoading](state, payload: boolean) {
        state.isChatroomLoading = payload;
    },
    [WeChatMutations.setIsSessionAllLoaded](state, payload: boolean) {
        state.isSessionAllLoaded = payload;
    },
    [WeChatMutations.SetIsContactAllLoaded](state, payload: boolean) {
        state.isContactAllLoaded = payload;
    },
    [WeChatMutations.setIsChatroomAllLoaded](state, payload: boolean) {
        state.isChatroomAllLoaded = payload;
    },
    [WeChatMutations.setIsMsgListLoading](state, payload: boolean) {
        state.isMsgListLoading = payload;
    },
    [WeChatMutations.setIsPaticipantsLoading](state, payload: boolean) {
        state.isParticipantsLoading = payload;
    },
    [WeChatMutations.setSelectedSession](state, payload: WeChatSession | WeChatContact) {
        state.selectedSession = payload;
    },
    [WeChatMutations.setSessionPagination](state, payload: WeChatPagination) {
        state.sessionPagination = payload;
    },
    [WeChatMutations.setContactPagination](state, payload: WeChatPagination) {
        state.contactPagination = payload;
    },
    [WeChatMutations.setChatroomPagination](state, payload: WeChatPagination) {
        state.chatroomPagination = payload;
    },
    [WeChatMutations.setMsgListByName](state, payload: { sessionName: string, msgList: WeChatMsg[], isAppend: boolean }) {
        const msgGroup = state.msgListMap[payload.sessionName];
        if (!msgGroup) {
            state.msgListMap[payload.sessionName] = {
                msgList: payload.msgList,
                pagination: { ...defaultPagination },
                isAllLoaded: false,
            }
            return;
        }

        if (payload.isAppend) {
            msgGroup.msgList = msgGroup.msgList.concat(payload.msgList);
        } else {
            msgGroup.msgList = payload.msgList;
        }
    },
    [WeChatMutations.setMsgPaginationByName](state, payload: { sessionName: string, pagination: WeChatPagination }) {
        const msgGroup = state.msgListMap[payload.sessionName];
        if (msgGroup) {
            msgGroup.pagination = payload.pagination;
        } else {
            state.msgListMap[payload.sessionName] = {
                msgList: [],
                pagination: payload.pagination,
                isAllLoaded: false,
            }
        }
    },
    [WeChatMutations.setMsgAllLoadedByName](state, payload: { sessionName: string, isAllLoaded: boolean }) {
        const msgGroup = state.msgListMap[payload.sessionName];
        if (msgGroup) {
            msgGroup.isAllLoaded = payload.isAllLoaded;
        } else {
            state.msgListMap[payload.sessionName] = {
                msgList: [],
                pagination: { ...defaultPagination },
                isAllLoaded: payload.isAllLoaded,
            }
        }
    },
    [WeChatMutations.setChatroomGroupByName](state, payload: { chatroomName: string, userList: WeChatContact[], isAppend: boolean }) {
        const msgGroup = state.chatroomParticipantsMap[payload.chatroomName];
        if (!msgGroup) {
            state.chatroomParticipantsMap[payload.chatroomName] = {
                userList: payload.userList,
                pagination: { ...defaultPagination },
                isAllLoaded: false,
            }
            return;
        }
        if (payload.isAppend) {
            msgGroup.userList = msgGroup.userList.concat(payload.userList);
        } else {
            msgGroup.userList = payload.userList;
        }
    },
    [WeChatMutations.setParticipantsPaginationByName](state, payload: { chatroomName: string, pagination: WeChatPagination }) {
        const msgGroup = state.chatroomParticipantsMap[payload.chatroomName];
        if (msgGroup) {
            msgGroup.pagination = payload.pagination;
        } else {
            state.chatroomParticipantsMap[payload.chatroomName] = {
                userList: [],
                pagination: payload.pagination,
                isAllLoaded: false,
            }
        }
    },
    [WeChatMutations.setParticipantsAllLoadedByName](state, payload: { chatroomName: string, isAllLoaded: boolean }) {
        const msgGroup = state.chatroomParticipantsMap[payload.chatroomName];
        if (msgGroup) {
            msgGroup.isAllLoaded = payload.isAllLoaded;
        } else {
            state.chatroomParticipantsMap[payload.chatroomName] = {
                userList: [],
                pagination: { ...defaultPagination },
                isAllLoaded: payload.isAllLoaded,
            }
        }
    },

    [WeChatMutations.setChatroom](state, payload: WeChatChatroom) {
        state.chatroom = payload;
    },
    [WeChatMutations.setChatroomInfo](state, payload: WeChatChatroomInfo) {
        state.chatroomInfo = payload;
    },
    [WeChatMutations.setMeId](state, payload: string) {
        state.me = payload;
    },
    [WeChatMutations.setIdList](state, payload: WeChatContact[]) {
        state.idList = payload;
    },
    [WeChatMutations.setIsMeLoading](state, payload: boolean) {
        state.isMeLoading = payload;
    },
    [WeChatMutations.setSelectMenu](state, payload: string) {
        state.selectedMenu = payload;
    },
    [WeChatMutations.resetAll](state) {
        Object.assign(state, {
            ...defaultState,
            sessionList: [],
            contactList: [],
            chatroomList: [],
            msgListMap: {},
            chatroomParticipantsMap: {},
            contactPagination: { ...defaultPagination },
            chatroomPagination: { ...defaultPagination },
            sessionPagination: { ...defaultPagination },
        })
    },

    [WeChatMutations.setSearchTarget](state, payload: string): void {
        state.searchTarget = payload
    },
    [WeChatMutations.setSearchType](state, payload: string): void {
        state.searchType = payload
    },
    [WeChatMutations.setSearchContactList](state, payload: { contactList: WeChatSession[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.searchingContact = state.searchingContact.concat(payload.contactList);
        } else {
            state.searchingContact = payload.contactList;
        }
    },
    [WeChatMutations.setSearchConvList](state, payload: { convList: WeChatSession[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.searchingConversation = state.searchingConversation.concat(payload.convList);
        } else {
            state.searchingConversation = payload.convList;
        }
    },
    [WeChatMutations.setSearchChatList](state, payload: { chatList: WeChatSession[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.searchingChat = state.searchingChat.concat(payload.chatList);
        } else {
            state.searchingChat = payload.chatList;
        }
    },
    [WeChatMutations.setIsSearchContactLoading](state, payload: boolean) {
        state.isSearchingContactLoading = payload;
    },
    [WeChatMutations.setIsSearchConvLoading](state, payload: boolean) {
        state.isSearchingConvLoading = payload;
    },
    [WeChatMutations.setIsSearchChatLoading](state, payload: boolean) {
        state.isSearchingChatLoading = payload;
    },
    [WeChatMutations.setIsSearchContactAllLoaded](state, payload: boolean) {
        state.isSearchingContactAllLoaded = payload;
    },
    [WeChatMutations.setIsSearchConvAllLoaded](state, payload: boolean) {
        state.isSearchingConvAllLoaded = payload;
    },
    [WeChatMutations.setIsSearchChatAllLoaded](state, payload: boolean) {
        state.isSearchingChatAllLoaded = payload;
    },
    [WeChatMutations.setSearchContactPagination](state, payload: WeChatPagination) {
        state.searchingContactPagination = payload;
    },
    [WeChatMutations.setSearchConvPagination](state, payload: WeChatPagination) {
        state.searchingConvPagination = payload;
    },
    [WeChatMutations.setSearchChatPagination](state, payload: WeChatPagination) {
        state.searchingChatPagination = payload;
    },
    [WeChatMutations.setSearchMsgListByName](state, payload: { name: string, msgList: WeChatMsg[], isAppend: boolean }) {
        const msgGroup = state.searchMsgListMap[payload.name];
        if (!msgGroup) {
            state.searchMsgListMap[payload.name] = {
                msgList: payload.msgList,
                pagination: { ...defaultPagination },
                isAllLoaded: false,
            }
            return;
        }

        if (payload.isAppend) {
            state.searchMsgListMap[payload.name].msgList = msgGroup.msgList.concat(payload.msgList);
        } else {
            state.searchMsgListMap[payload.name].msgList = payload.msgList;
        }
    },
    [WeChatMutations.setIsSearchMsgLoading](state, payload: boolean) {
        state.isSearchingMsgLoading = payload;
    },
    [WeChatMutations.setSearchMsgPaginationByConvId](state, payload: { name: string, pagination: WeChatPagination }) {
        const msgGroup = state.searchMsgListMap[payload.name];
        if (msgGroup) {
            msgGroup.pagination = payload.pagination;
        } else {
            state.searchMsgListMap[payload.name] = {
                msgList: [],
                pagination: payload.pagination,
                isAllLoaded: false,
            }
        }
    },
    [WeChatMutations.setSearchMsgAllLoadedByConvId](state, payload: { name: string, isAllLoaded: boolean }) {
        const msgGroup = state.searchMsgListMap[payload.name];
        if (msgGroup) {
            msgGroup.isAllLoaded = payload.isAllLoaded;
        } else {
            state.searchMsgListMap[payload.name] = {
                msgList: [],
                pagination: { ...defaultPagination },
                isAllLoaded: payload.isAllLoaded,
            }
        }
    },
    [WeChatMutations.resetSearch](state) {
        Object.assign(state, {
            searchingContact: [],
            searchingConversation: [],
            searchingChat: [],
            isSearchingContactLoading: false,
            isSearchingConvLoading: false,
            isSearchingChatLoading: false,
            isSearchingContactAllLoaded: false,
            isSearchingConvAllLoaded: false,
            isSearchingChatAllLoaded: false,
            searchingContactPagination: { ...defaultPagination },
            searchingConvPagination: { ...defaultPagination },
            searchingChatPagination: { ...defaultPagination },
            searchMsgListMap: {},
            isSearchingMsgLoading: false,
        })
    },

}

export const actions: ActionTree<WeChatState, RootState> = {
    async [WeChatActions.asyncGetSessionListByUid]({ commit, getters }: ActionContext<WeChatState, RootState>, { projId, uid, wechatId, isAppend }: { projId: string, uid: string, wechatId: string, isAppend: string }) {
        try {
            commit(WeChatMutations.setIsSessionLoading, true);
            const sessionPagination = getters[WeChatGetters.getSessionPagination];
            const sessionList = await weChatAPI.getSessionListByUid({ projId: projId, uid: uid, wechatId: wechatId, ...sessionPagination });
            commit(WeChatMutations.setWeChatSessionList, { sessionList, isAppend });
            commit(WeChatMutations.setSessionPagination, { ...sessionPagination, page: sessionPagination.page + 1 });

            if (sessionList.length < sessionPagination.limit) {
                commit(WeChatMutations.setIsSessionAllLoaded, true);
            }
        } catch (err) {
            commit(WeChatMutations.setIsSessionAllLoaded, true);
            console.log(err);
        } finally {
            commit(WeChatMutations.setIsSessionLoading, false);
        }
    },
    async [WeChatActions.asyncGetContactListByUid]({ commit, getters }: ActionContext<WeChatState, RootState>, { projId, uid, wechatId, isAppend }: { projId: string, uid: string, wechatId: string, isAppend: string }) {
        try {
            commit(WeChatMutations.SetIsContactLoading, true);
            const contactPagination = getters[WeChatGetters.getContactPagination];
            const contactList = await weChatAPI.getContactListByUid({ projId: projId, uid: uid, wechatId: wechatId, ...contactPagination });
            commit(WeChatMutations.SetWeChatContactList, { contactList, isAppend });
            commit(WeChatMutations.setContactPagination, { ...contactPagination, page: contactPagination.page + 1 });

            if (contactList.length < contactPagination.limit) {
                commit(WeChatMutations.SetIsContactAllLoaded, true);
            }
        } catch (err) {
            commit(WeChatMutations.SetIsContactAllLoaded, true);
            console.log(err);
        } finally {
            commit(WeChatMutations.SetIsContactLoading, false);
        }
    },
    async [WeChatActions.asyncGetChatroomListByUid]({ commit, getters }: ActionContext<WeChatState, RootState>, { projId, uid, wechatId, isAppend }: { projId: string, uid: string, wechatId: string, isAppend: string }) {
        try {
            commit(WeChatMutations.setIsChatroomLoading, true);
            const chatroomPagination = getters[WeChatGetters.getChatRoomPagination];
            const chatroomList = await weChatAPI.getChatrooomListByUid({ projId: projId, uid: uid, wechatId: wechatId, ...chatroomPagination });
            commit(WeChatMutations.setWeChatChatroomList, { chatroomList, isAppend });
            commit(WeChatMutations.setChatroomPagination, { ...chatroomPagination, page: chatroomPagination.page + 1 });

            if (chatroomList.length < chatroomPagination.limit) {
                commit(WeChatMutations.setIsChatroomAllLoaded, true);
            }
        } catch (err) {
            console.log(err);
        } finally {
            commit(WeChatMutations.setIsChatroomAllLoaded, true);
            commit(WeChatMutations.setIsChatroomLoading, false);
        }
    },
    async [WeChatActions.asyncGetMsgListByUidAndName]({ commit, getters }: ActionContext<WeChatState, RootState>, { projId, uid, wechatId, name }: { projId: string, uid: string, wechatId: string, name: string }) {
        try {
            commit(WeChatMutations.setIsMsgListLoading, true);
            const msgGroup = getters[WeChatGetters.getMsgGroupByName](name);
            const currentPagination = msgGroup.pagination;
            let msgList: WeChatMsg[] = [];

            msgList = await weChatAPI.asyncGetMsgListByUidAndName({ projId: projId, uid: uid, wechatId: wechatId, name: name, ...currentPagination });

            if (msgList.length < currentPagination.limit) {
                commit(WeChatMutations.setMsgAllLoadedByName, { sessionName: name, isAllLoaded: true });
            }
            commit(WeChatMutations.setMsgListByName, { sessionName: name, msgList: msgList, isAppend: true });
            commit(WeChatMutations.setMsgPaginationByName, {
                sessionName: name,
                pagination: {
                    ...currentPagination,
                    page: currentPagination.page + 1,
                }
            });
        } catch (err) {
            commit(WeChatMutations.setMsgAllLoadedByName, { sessionName: name, isAllLoaded: true });
            console.log(err);
        } finally {
            commit(WeChatMutations.setIsMsgListLoading, false);
        }
    },
    async [WeChatActions.asyncGetChatroomByUidAndName]({ commit }: ActionContext<WeChatState, RootState>, { uid, name }: { uid: string, name: string }) {
        try {
            commit(WeChatMutations.setIsChatroomLoading, true);
            const chatroom = await weChatAPI.asyncGetChatroomByUidAndName({ uid: uid, name: name });
            commit(WeChatMutations.setChatroom, chatroom);
        } catch (err) {
            console.log(err);
        } finally {
            commit(WeChatMutations.setIsChatroomLoading, false);
        }
    },
    async [WeChatActions.asyncGetParticipantsByChatroomName]({ commit, getters }: ActionContext<WeChatState, RootState>, { projId, uid, wechatId, chatroomName }: { projId: string, uid: string, wechatId: string, chatroomName: string }) {
        try {
            commit(WeChatMutations.setIsPaticipantsLoading, true);
            const chatroomGroup = getters[WeChatGetters.getChatroomGroupByName](chatroomName);
            const currentPagination = chatroomGroup.pagination;
            let userList: WeChatContact[] = [];
            userList = await weChatAPI.getParticipantsByChatroomName({ projId: projId, uid: uid, wechatId: wechatId, chatroomName: chatroomName, ...currentPagination });
            if (userList.length < currentPagination.limit) {
                commit(WeChatMutations.setParticipantsAllLoadedByName, { chatroomName: chatroomName, isAllLoaded: true });
            }
            commit(WeChatMutations.setChatroomGroupByName, { chatroomName: chatroomName, userList: userList, isAppend: true });
            commit(WeChatMutations.setParticipantsPaginationByName, {
                chatroomName: chatroomName,
                pagination: {
                    ...currentPagination,
                    page: currentPagination.page + 1,
                }
            });
        } catch (err) {
            commit(WeChatMutations.setParticipantsAllLoadedByName, { chatroomName: chatroomName, isAllLoaded: true });
            console.log(err);
        } finally {
            commit(WeChatMutations.setIsPaticipantsLoading, false);
        }
    },
    // async [WeChatActions.asyncGetChatroomInfoByUidAndName]({ commit }: ActionContext<WeChatState, RootState>, { uid, name }: { uid: string, name: string }) {
    //     try {
    //         commit(WeChatMutations.setIsChatroomLoading, true);
    //         const chatroomInfo = await weChatAPI.asyncGetChatroomInfoByUidAndName({ uid: uid, name: name });
    //         commit(WeChatMutations.setChatroom, chatroomInfo);
    //     } catch (err) {
    //         console.log(err);
    //     } finally {
    //         commit(WeChatMutations.setIsChatroomLoading, false);
    //     }
    // },
    async [WeChatActions.asyncGetMeId]({ commit, getters }: ActionContext<WeChatState, RootState>, { projid, uid }: { projid: string, uid: string }) {
        try {
            commit(WeChatMutations.setIsMeLoading, true);
            const nowId = getters[WeChatGetters.getMeId];

            const res = await weChatAPI.asyncGetWechatIdByProjIdAndUid({ projid, uid })
            commit(WeChatMutations.setIdList, res);

            if (res.length !== 0) {
                commit(WeChatMutations.setMeId, nowId === "" ? res[0].UserName : nowId);
            } else {
                commit(WeChatMutations.setIsSessionAllLoaded, true);
                commit(WeChatMutations.SetIsContactAllLoaded, true);
                commit(WeChatMutations.setIsChatroomAllLoaded, true);
            }
        } catch (err) {
            console.log(err);
        } finally {
            commit(WeChatMutations.setIsMeLoading, false);
        }
    },

    async [WeChatActions.asyncGetSearchingContactByUidAndTgId]({ commit, getters }: ActionContext<WeChatState, RootState>,
        { projId, uid, wechatId, isAppend, target }: { projId: string, uid: string, wechatId: string, isAppend: boolean, target: string }) {
        try {
            commit(WeChatMutations.setIsSearchContactLoading, true);
            const searchContactPagination = getters[WeChatGetters.getSearchContactPagination];

            const contactList = await weChatAPI.asyncFuzzySearchWeChatContact({ projid: projId, uid: uid, wechatId: wechatId, ...searchContactPagination, target: target });
            commit(WeChatMutations.setSearchContactList, { contactList, isAppend });
            commit(WeChatMutations.setSearchContactPagination, { ...searchContactPagination, page: searchContactPagination.page + 1 });
            if (contactList.length < searchContactPagination.limit) {
                commit(WeChatMutations.setIsSearchContactAllLoaded, true);
            }
        } catch (err) {
            commit(WeChatMutations.setIsSearchContactAllLoaded, true);
            console.log(err)
        } finally {
            commit(WeChatMutations.setIsSearchContactLoading, false);
        }
    },
    async [WeChatActions.asyncGetSearchingConvByUidAndTgId]({ commit, getters }: ActionContext<WeChatState, RootState>,
        { projId, uid, wechatId, isAppend, target }: { projId: string, uid: string, wechatId: string, isAppend: boolean, target: string }) {
        try {
            commit(WeChatMutations.setIsSearchConvLoading, true);
            const searchConvPagination = getters[WeChatGetters.getSearchConvPagination];
            const convList = await weChatAPI.asyncFuzzySearchWeChatConv({ projid: projId, uid: uid, wechatId: wechatId, ...searchConvPagination, target: target });
            commit(WeChatMutations.setSearchConvList, { convList, isAppend });
            commit(WeChatMutations.setSearchConvPagination, { ...searchConvPagination, page: searchConvPagination.page + 1 });
            if (convList.length < searchConvPagination.limit) {
                commit(WeChatMutations.setIsSearchConvAllLoaded, true);
            }
        } catch (err) {
            commit(WeChatMutations.setIsSearchConvAllLoaded, true);
            console.log(err)
        } finally {
            commit(WeChatMutations.setIsSearchConvLoading, false);
        }
    },
    async [WeChatActions.asyncGetSearchingChatByUidAndTgId]({ commit, getters }: ActionContext<WeChatState, RootState>,
        { projId, uid, wechatId, isAppend, target }: { projId: string, uid: string, wechatId: string, isAppend: boolean, target: string }) {
        try {
            commit(WeChatMutations.setIsSearchChatLoading, true);
            const searchChatPagination = getters[WeChatGetters.getSearchChatPagination];
            const chatList = await weChatAPI.asyncFuzzySearchWeChatChat({ projid: projId, uid: uid, wechatId: wechatId, ...searchChatPagination, target: target });
            commit(WeChatMutations.setSearchChatList, { chatList, isAppend });
            commit(WeChatMutations.setSearchChatPagination, { ...searchChatPagination, page: searchChatPagination.page + 1 });
            if (chatList.length < searchChatPagination.limit) {
                commit(WeChatMutations.setIsSearchChatAllLoaded, true);
            }
        } catch (err) {
            commit(WeChatMutations.setIsSearchChatAllLoaded, true);
            console.log(err)
        } finally {
            commit(WeChatMutations.setIsSearchChatLoading, false);
        }
    },

    async [WeChatActions.asyncGetSearchingMsgByNameAndTarget]({ commit, getters }: ActionContext<WeChatState, RootState>,
        { projId, uid, wechatId, name, target, isAppend }: { projId: string, uid: string, wechatId: string, name: string, target: string, isAppend: boolean }) {
        try {
            commit(WeChatMutations.setIsSearchMsgLoading, true);
            const msgGroup = getters[WeChatGetters.getSearchMsgListMap](name);
            const currentPagination = isAppend ? msgGroup.pagination : defaultPagination;
            // TODO to be changed to function map or to be changed in backend.
            let msgList: WeChatMsg[] = [];
            msgList = await weChatAPI.asyncGetMsgListForSearchResultOfWechatConv({ projid: projId, uid: uid, wechatId: wechatId, name: name, target: target, ...currentPagination });

            // msgList = msgList ? msgList : [];
            if (msgList.length < currentPagination.limit) {
                commit(WeChatMutations.setSearchMsgAllLoadedByConvId, { name: name, isAllLoaded: true });
            }

            commit(WeChatMutations.setSearchMsgListByName, { name: name, msgList: msgList, isAppend: isAppend });
            commit(WeChatMutations.setSearchMsgPaginationByConvId, {
                name: name,
                pagination: {
                    ...currentPagination,
                    page: currentPagination.page + 1,
                }
            })
        } catch (err) {
            commit(WeChatMutations.setSearchMsgAllLoadedByConvId, { name: name, isAllLoaded: true });
            console.log(err)
        } finally {
            commit(WeChatMutations.setIsSearchMsgLoading, false);
        }
    },
    async [WeChatActions.asyncGetSearchingMsgByNameAndUserId]({ commit, getters }: ActionContext<WeChatState, RootState>,
        { projId, uid, wechatId, name, userId, isAppend }: { projId: string, uid: string, wechatId: string, name: string, userId: number, isAppend: boolean }) {
        try {
            commit(WeChatMutations.setIsSearchMsgLoading, true);
            const msgGroup = getters[WeChatGetters.getSearchMsgListMap](name);
            const currentPagination = isAppend ? msgGroup.pagination : defaultPagination;
            // TODO to be changed to function map or to be changed in backend.
            let msgList: WeChatMsg[] = [];
            msgList = await weChatAPI.asyncGetMsgListForSearchResultOfWechatChat({ projid: projId, uid: uid, wechatId: wechatId, name: name, userid: userId, ...currentPagination });

            // msgList = msgList ? msgList : [];
            if (msgList.length < currentPagination.limit) {
                commit(WeChatMutations.setSearchMsgAllLoadedByConvId, { name: name, isAllLoaded: true });
            }

            commit(WeChatMutations.setSearchMsgListByName, { name: name, msgList: msgList, isAppend: isAppend });
            commit(WeChatMutations.setSearchMsgPaginationByConvId, {
                name: name,
                pagination: {
                    ...currentPagination,
                    page: currentPagination.page + 1,
                }
            })
        } catch (err) {
            commit(WeChatMutations.setSearchMsgAllLoadedByConvId, { name: name, isAllLoaded: true });
            console.log(err)
        } finally {
            commit(WeChatMutations.setIsSearchMsgLoading, false);
        }
    },


}

export const weChat: Module<WeChatState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}